import { html } from 'lit';

export const iconCheckmarkCircleTransparent = html`
  <svg
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    viewBox="0 0 32 32"
  >
    <path
      fill="currentColor"
      d="M14.688 20.75c-0.375 0.375-1.063 0.375-1.438 0l-4-4c-0.375-0.375-0.375-1.063 0-1.438s1.063-0.375 1.438 0l3.313 3.313 7.25-7.313c0.375-0.375 1.063-0.375 1.438 0s0.375 1.063 0 1.438l-8 8zM32 16c0 8.875-7.188 16-16 16-8.875 0-16-7.125-16-16 0-8.813 7.125-16 16-16 8.813 0 16 7.188 16 16zM16 2c-7.75 0-14 6.313-14 14 0 7.75 6.25 14 14 14 7.688 0 14-6.25 14-14 0-7.688-6.313-14-14-14z"
    ></path>
  </svg>
`;
